import React from 'react'
import './index.scss'

interface ISearchBarProps {
  clickTo: (
    type: string,
    path1?: string,
    path2?: string,
    componentId?: string
  ) => void
  id: string
}

const SearchBar = (props: ISearchBarProps) => {
  const { clickTo, id } = props
  return (
    <div
      className="lego_searchBarContent"
      onClick={() => clickTo('searchBar', '', '', id)}
    >
      <div className="searchInput">
        <img
          className="searchIcon"
          src="https://baleen-cdn-g.bybieyang.com/by/lego/2c609edd0c03d73f30e5d09d17acda79.png"
        ></img>
        <div className="input">search</div>
      </div>
    </div>
  )
}

export default SearchBar
